export default "/images/vendor/flag-icon-css/flags/1x1/fi.svg?a2a21809fce58fba7e9dd3f50bacc0e0";